export default {
  custom: () => import("/home/gerard/Work/vawarelabs/asufin/asufin-panel-v2/layouts/custom.vue").then(m => m.default || m),
  default: () => import("/home/gerard/Work/vawarelabs/asufin/asufin-panel-v2/layouts/default.vue").then(m => m.default || m),
  "landing-downloads": () => import("/home/gerard/Work/vawarelabs/asufin/asufin-panel-v2/layouts/landing-downloads.vue").then(m => m.default || m),
  register: () => import("/home/gerard/Work/vawarelabs/asufin/asufin-panel-v2/layouts/register.vue").then(m => m.default || m)
}